<template>
  <el-row class="warp">
      <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
        <el-col :span="24" class="warp-main">
        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-form :inline="true" :model="filters" ref="filtersForm">
            <el-form-item label="告警类型名称" prop="name">
                <el-input v-model="filters.name" placeholder="告警类型名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="告警类型编码" prop="code">
                <el-input v-model="filters.code" placeholder="告警类型编码" clearable></el-input>
            </el-form-item>
            <el-form-item label="设备供应商">
                <el-input v-model="filters.deviceSupplierName" placeholder="告警类型名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="玉平告警大类">
                <el-input v-model="filters.ypEventTypeName" placeholder="告警类型名称" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handleSearch">查询</el-button>
                <el-button type="primary" @click="resetForm">重置</el-button>
            </el-form-item>
            </el-form>
        </el-col>
        <!--列表-->
        <el-table ref="multipleTable" 
        :data="eventDicts" 
        highlight-current-row 
        border 
        style="width: 100%;"   
        height="400"
        @selection-change="handleSelectionChange"
        :row-key="rowKey"
        >
            <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
            <el-table-column prop="name" label="告警事件名称" width="200" fixed="left" align="center"></el-table-column>
            <el-table-column prop="code" label="告警编码" width="100" fixed="left" align="center"></el-table-column>
            <el-table-column prop="deviceSupplierName" label="供应商"  fixed="left" width="250"  align="center"></el-table-column>
            <el-table-column prop="ypEventTypeName" label="玉平告警大类" width="250"  align="center"></el-table-column>
            <el-table-column prop="ypEventTypeParentName" label="大类父类" width="250"  align="center"></el-table-column>
            <el-table-column prop="remark" label="描述" width="550" align="center"></el-table-column>
        </el-table>
        </el-col>
        <el-col :span="24" class="toolbar"  style="margin-top:10px;">
            <el-badge :value="selectEvents.length" :max="100" class="item" style="float:right;margin-right:50px;">
                <el-button type="success" @click="selectSure" >确定选择</el-button>
            </el-badge>
        </el-col>
      </el-col>
    
  </el-row>
</template>
<script>
import API from '../../api/device/api_deviceEventDictionary';

export default {
  props:{
    events:{ type: Array, default: []},
    openflg:{type:Number,default:-1}
  },
  data() {
    return {
      loading: false,
      eventDicts: [],
      eventDictsTemp:[],
      allSupplier:[],
      ypEventTypes:[],
      filters: {
          name:"",
          code:""
      },
      selectEvents:[]
    }
  },
  methods: {
      rowKey:function(row){
        return row.id;
      },
    supplierSelect:function(){
          let that = this;
          API.allSupplier({})
          .then(
              function(result) {
                console.log(result);
                if (result && result.code == 200) {
                  that.allSupplier= result.data;
                }
              },
              function(error) {
                that.$message.error({
                  showClose: true,
                  message: error.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error){
              that.$message.error({
                showClose: true,
                message: '请求出现异常',
                duration: 2000
              });
            });
    },
    //查询玉平告警大类
    getYPEventType:function(){
      let that = this;
      API.getDictCombox({code:"YPEventType"})
      .then(
          function (result) {
            console.log(result);
            if(result.code==200){
              that.ypEventTypes = result.data;
            }
          }, 
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
        })
        .catch(function (error) {
          that.loading = false;
          // console.log(error);
          that.$message.error({
            showClose: true,
            message: '请求出现异常',
            duration: 2000
          });
        });
    },
    resetForm() {
      this.$refs.filtersForm.resetFields();
      this.handleSearch();
    },
    search() {
      let that = this;
      let params = Object.assign(that.filters);
      that.loading = true;
      API.getAllList(params)
      .then(
        function(result){
          if (result && result.code == 200) {
            that.eventDicts= result.data;
            that.eventDictsTemp = result.data;
            let eventSelect =[];
            that.eventDicts.forEach(s=>{
                let temp = that.events.find(f=>f.id ==s.id);
                if(temp){
                    eventSelect.push(s);
                }
            });
            that.$nextTick(() => {
                that.$refs.multipleTable.clearSelection();
                 if(eventSelect){
                    eventSelect.forEach(row=>{
                        that.$refs.multipleTable.toggleRowSelection(row, true)
                    })
                 }
            });
          }
        },
        function(error){
            that.$message.error({
                showClose: true,
                message: error.toString(),
                duration: 2000
            });
        }
      )
      .catch(function(error){
            that.$message.error({
                showClose: true,
                message: '请求出现异常',
                duration: 2000
            });
        });
       that.loading = false;
    },
    handleSearch() {
      this.eventDicts = this.eventDictsTemp.filter(data => (!this.filters.name || (data.name && data.name.indexOf(this.filters.name)>-1))
        && (!this.filters.code || (data.code && data.code.indexOf(this.filters.code)>-1))
        && (!this.filters.deviceSupplierName || (data.deviceSupplierName && data.deviceSupplierName.indexOf(this.filters.deviceSupplierName)>-1))
        && (!this.filters.ypEventTypeName || (data.ypEventTypeName && data.ypEventTypeName.indexOf(this.filters.ypEventTypeName)>-1))
      )
    },
    //勾选
    handleSelectionChange(val){
        this.selectEvents = val;
    },
    //确定
    selectSure:function(){
         this.$emit('getSelectData',this.selectEvents);
    }
  },
  mounted() {
    let that = this;
    that.selectEvents =that.events;
    this.$refs.filtersForm.resetFields();
    this.search();
  },
  watch: {
        openflg(){
            let that = this;
            that.selectEvents =that.events;
            this.$refs.filtersForm.resetFields();
            this.search();
        }
  }
};
</script>


// WEBPACK FOOTER //
// event.vue?0eced420